import { render } from "./Header.vue?vue&type=template&id=be406888&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=be406888&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-be406888"

export default script